<template>
  <div class="first-time-modal">
    <modal-header
      :logo-img-src="require('@/assets/image/homebase/aone_logo.svg')"
      :on-modal-close="close"
    ></modal-header>
    <div class="d-flex justify-content-center pt-3 pb-5">
      <div class="modal-body text-center">
        <div class="welcome-msg">
          Welcome to the <span class="modal-text-bold">new</span>
        </div>
        <div class="pb-2 pr-xl-2">
          <img
            class="aone-logo"
            src="@/assets/image/homebase/aone_logo_black.svg"
            alt="Autodesk One"
          />
        </div>
        <div class="modal-description pb-4">
          We've integrated <span class="modal-text-bold">Employee Hub</span> and
          <span class="modal-text-bold">Autodesk One</span>. View the video to
          learn more.
        </div>
        <div style="max-width: 640px">
          <div>
            <video controls poster="https://del6fkf4zntcx.cloudfront.net/images/AutodeskOne-video-poster.png">
              <source
                src="https://del6fkf4zntcx.cloudfront.net/videos/autodeskone-merger-video.mp4"
                type="video/mp4"
              />
            </video>
          </div>
        </div>
      </div>
    </div>
    <modal-footer
      class="text-center"
      :buttonConfigs="[buttonConfig]"
    ></modal-footer>
  </div>
</template>

<script>
import * as CONSTANTS from "@/store/constants";
import { mapMutations } from "vuex";

import ModalHeader from "./ModalHeader";
import ModalFooter from "./ModalFooter";
import HomebaseMixpanelMixin from "@/mixins/HomebaseMixpanelMixin";

export default {
  name: "first-time-visit-modal",
  mixins: [HomebaseMixpanelMixin],
  components: {
    ModalHeader,
    ModalFooter,
  },
  data() {
    return {
      buttonConfig: {
        text: "Get Started",
        clickHandler: this.done,
        class: "homebase-btn-primary",
      },
    };
  },
  methods: {
    ...mapMutations(["setGetStartedClicked"]),
    close() {
      this.$emit("close");
    },
    done() {
      this.trackFirstTimeVisitClick();
      window.localStorage.setItem(CONSTANTS.AONE_FIRST_TIME_VISIT_KEY, true);
      this.setGetStartedClicked(true);
      this.close();
    },
  },
};
</script>

<style scoped>
.welcome-msg {
  font-size: 24px;
}
.modal-text-bold {
  font-family: artifaktElementExtraBold !important;
}
.modal-description {
  font-size: 18px;
}
.modal-body {
  max-width: 480px;
  min-height: 400px;
}
.aone-logo {
  width: 80%;
  margin-top: -6px;
}

video {
  width: 100%;
  max-height: 100%;
  object-fit: cover;
}
</style>

<style>
/* only increase overlay opacity for this modal */
.v--modal-overlay:has(.first-time-modal) {
  background: rgba(0, 0, 0, 0.5);
}
</style>



// WEBPACK FOOTER //
// src/components/homebase/modals/FirstTimeVisitModal.vue